import { useState } from 'react';
import UI from '../ui';
import { useNavigate } from 'react-router';

const WelcomePage: React.FC = () => {
  const [placeSearch, setPlaceSearch] = useState('');
  const navigate = useNavigate();
  return (
    <UI.VerticalLayout align="center" width="100%" height="100%" justify="space-between">
      <UI.HorizontalLayout gap={5} width="100%">
        <UI.Textfield
          placeHolder="Where to?"
          value={placeSearch}
          onChange={setPlaceSearch}
          startIcon="search"
          width="100%"
        />
        <UI.Button label="Search" type="tertiary" onClick={() => {}} />
      </UI.HorizontalLayout>
      <UI.VerticalLayout align="center">
        <img
          style={{ maxWidth: '334px' }}
          alt="Traveller woman with map and suitcase"
          src="./assets/welcome_screen.png"
        />
        <UI.VerticalLayout align="start">
          <UI.Text weight="bold" size="title">
            Join Zylo and see where your friends have been to!
          </UI.Text>
          {/* <UI.Text>
            Lorem ipsum dolor sit amet
          </UI.Text> */}
        </UI.VerticalLayout>
      </UI.VerticalLayout>
      <UI.VerticalLayout gap={10} width="100%">
        <UI.Button label="Log in" onClick={() => navigate('/login')} type="primary" />
        <UI.Text align="center">
          Don't have an account?
          &nbsp;
          <UI.TextLink path="/register">Register</UI.TextLink>
        </UI.Text>
      </UI.VerticalLayout>
    </UI.VerticalLayout>
  );
};

export default WelcomePage;
